export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-queue/src/array.js
// module id = 1128
// module chunks = 4